import { useView } from '@10000/react'
import { DateFormatter, MoneyFormatter, Table } from './table'
import { subscriptions } from '../../../lookups'

export const SubscriptionTable = () => {
  const { subscription } = useView('tenant')

  const columns = [
    { key: 'ends', name: 'Ends', formatter: DateFormatter },
    { key: 'type', name: 'Type' },
    { key: 'teams', name: 'Teams' },
    { key: 'price', name: 'Price', formatter: MoneyFormatter }
  ]

  const rows = [{
    ends: subscription?.ends,
    type: subscriptions[subscription?.index]?.type,
    teams: subscriptions[subscription?.index]?.teams,
    price: subscriptions[subscription?.index]?.price,
  }]

  return (
    <Table
      title="Subscription"
      rows={rows}
      columns={columns}
      defaultSortColumn="ends"
    />
  )
}